import CustomReceiptList from "./CustomReceiptList";
export default CustomReceiptList;
